import React from 'react'
import { Chart } from './chart'
import { config } from './config'
import './styles.scss'
interface GenderChartProps {
  curves: [number, number][][]
  keys: string[][]
  axisLabels?: { x?: string; y?: string }
  xDomain?: number[]
  yDomain?: number[]
  yTickStep?: number
  title?: string
  sub?: string
}
export const GenderChart: React.FC<GenderChartProps> = ({
  curves,
  keys,
  axisLabels,
  title,
  xDomain,
  yDomain,
  yTickStep,
  sub
}) => {
  return (
    <div className='GenderChart'>
      {title && <div className='title'>{title}</div>}
      {sub && <div className='sub'>{sub}</div>}
      <div className='key'>
        {keys.map((m, i) => (
          <div className={'entry' + (i === 2 ? ' _3' : "")} key={i}>
            <hr
              className={'line'}
              style={{ borderColor: m[1] }}
            />
            <div className='name' style={{ color: m[1] }}>
              {m[0]}
            </div>
          </div>
        ))}
      </div>
      <Chart
        curves={curves}
        keys={keys}
        axisLabels={axisLabels}
        xDomain={xDomain}
        yDomain={yDomain}
        yTickStep={yTickStep}
      />
    </div>
  )
}
